import React, {Component} from "react";  
import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import $ from "jquery";
import {css} from "@emotion/core";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {connect}  from  "react-redux";
import axios from "axios";
import {Link} from "react-router-dom";
import Switch from "react-switch";
import {BeatLoader} from 'react-spinners';
import { isApiResponse, isReportAccess, date_range_config, aplloClient, user_activities } from '../../helpers/utils.js';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align: center;
`;
function formatNumber(num) {
    //return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    var n1, n2;
    num = num + '' || '';
    // works for integer and floating as well
    n1 = num.split('.');
    n2 = n1[1] || null;
    n1 = n1[0].replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
    num = n2 ? n1 + '.' + n2 : n1;
    return num;
}
var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(todayDate).format('MM/DD/YYYY');
var yest = moment(todayDate).format('MM/DD/YYYY');
var todShow = moment(todayDate).format('D MMM YYYY');
var yestShow = moment(todayDate).format('D MMM YYYY');
var todSend = moment(todayDate).format('YYYY-MM-DD');
var yestSend = moment(todayDate).format('YYYY-MM-DD');
var date_limit = moment(todayDate).format('MM/DD/YYYY');
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};

function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}
function MergeGridCells() {
    var dimension_cells = new Array();
    var dimension_col = null;
    var columnCount = $("#BBIRTable tr:first th").length;
    //alert(columnCount)
    for (dimension_col = 0; dimension_col <= 1; dimension_col++) {
        // first_instance holds the first instance of identical td
        var first_instance = null;
        var rowspan = 1;
        // iterate through rows
        $("#BBIRTable").find('tr').each(function () {
            //console.log("sssssss");

            // find the td of the correct column (determined by the dimension_col set above)
            var dimension_td = $(this).find('td:nth-child(' + dimension_col + ')');



            if (first_instance === null) {
                // must be the first row
                first_instance = dimension_td;
            } else if (dimension_td.text() === first_instance.text()) {
                // the current td is identical to the previous
                // remove the current td
                // dimension_td.remove();
                dimension_td.attr('hidden', true);
                ++rowspan;
                // increment the rowspan attribute of the first instance
                first_instance.attr('rowspan', rowspan);
            } else {
                // this cell is different from the last
                first_instance = dimension_td;
                rowspan = 1;
            }
        });
    }
}
class BounceBackIndicatorReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            loading:true,
            model_visible : false,
            file_url: '',
            rfile: '',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            tableHeaders:[],
            tableBody:[],
            num_of_column:[]

        }
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidMount() {
        this.subMenuPermission();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });

        //console.log(decoded.object_type);
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: decoded.object_code,
        });

        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {

            this.get_BBIR_report();

            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Merchant') {
            var merchantData = [{"value":decoded.object_code, "label":""}]
            //this.changeMerchant(merchantData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
            this.get_BBIR_report('', this.state.yestSend, this.state.todSend)
        }
        else if(decoded.object_type=='Chain') {
            //this.getStore(decoded.object_code, 'chain', decoded.object_type, decoded.object_code);
            var chainData = [{"value":decoded.object_code, "label":""}]
            //this.changeChain(chainData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: true,
                acq_bank_list_box: true,
            })
            this.get_BBIR_report('', this.state.yestSend, this.state.todSend)
        }
        else if(decoded.object_type=='Store') {
            var storeData = [{"value":decoded.object_code, "label":""}]
            //this.changeStore(storeData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: true,
            })
            this.get_BBIR_report('', this.state.yestSend, this.state.todSend)
        }
     
        else {
            this.unauthorize_access();
        }
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'bounce_back_indicator','sparcs')
    }
    subMenuPermission(){
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        let reportPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });
        if(subMenuPermissions.includes("support_module")===false || reportPermissions.includes("user_login")===false ){
            this.unauthorize_access();
        }
    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }


    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){
            this.get_BBIR_report(this.state.uTypeIDs, this.state.yestSend, this.state.todSend)
        }
    }

    get_BBIR_report() {
        axios.post(config.get('API_URL') + '/reports/bbir_report', {

            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                //console.log(response.data.data[0]);
                this.setState({
                    loading:false
                })

            let tableHeaders = [];
            var no_of_rows = response.data.data.length;
            const keys = Object.keys(response.data.data[0]);
            keys.forEach(function (k) {
                //console.log(k)
                 tableHeaders.push(k);
            });
            var num_of_column = tableHeaders.length;
            //alert(num_of_column);
            this.setState({
                tableHeaders:tableHeaders,
                tableBody:response.data.data,
                num_of_column:num_of_column-2
            })
            setTimeout(function(){
                let total = '';
                let pageTotal = '';
                $('#BBIRTable').DataTable( {
                    searching: false,
                    bInfo : false,
                    paging: false,
                    "bSort": false,
                    "responsive": false,
                    "scrollX": true,
                    // "footerCallback": function ( row, data, start, end, display ) {
                    //         var api = this.api(), data;
                    //
                    //         // Remove the formatting to get integer data for summation
                    //         var intVal = function ( i ) {
                    //             i = i.toString();
                    //             return typeof i === 'string' ?
                    //                 i.replace('%', '')*1 :
                    //                 typeof i === 'number' ?
                    //                     i : 0;
                    //         };
                    //
                    //         // Total over all pages
                    //         total = api
                    //             .column( 0 )
                    //             .data()
                    //             .reduce( function (a, b) {
                    //                 return intVal(a) + intVal(b);
                    //             }, 0 );
                    //
                    //         // Total over this page
                    //         pageTotal = api
                    //             .column( 1, { page: 'current'} )
                    //             .data()
                    //             .reduce( function (a, b) {
                    //                 return intVal(a) + intVal(b);
                    //             }, 0 );
                    //         $( api.column( 0 ).footer() ).html(
                    //             'All Categories:'
                    //         );
                    //         $( api.column( 1 ).footer() ).html(
                    //             'All Cities:'
                    //         );
                    //         var last2 = num_of_column-3;
                    //         for(var i=2; i<= num_of_column-1; i++)
                    //         {
                    //             var api = this.api(),
                    //                 sum = 0;
                    //             api.rows(":not('.sgrouptotal')").every(function() {
                    //                 sum += parseFloat(this.data()[i]);
                    //             });
                    //                 var precentage = formatNumber(parseFloat(sum/5).toFixed( 2 )) +'%';
                    //                 if(i>last2){
                    //                     precentage = formatNumber(parseFloat(sum/5).toFixed( 2 )) ;
                    //                 }
                    //             $(api.column(i).footer()).text(precentage);
                    //         //     let total2 = api
                    //         //         .column( i, { page: 'current'} )
                    //         //         .data()
                    //         //         .reduce( function (a, b) {
                    //         //             return intVal(a) + intVal(b);
                    //         //         }, 0 );
                    //         //     var precentage = formatNumber(parseFloat(total2/no_of_rows).toFixed( 2 )) +'%';
                    //         //     if(i>last2){
                    //         //         precentage = formatNumber(parseFloat(total2).toFixed( 2 )) ;
                    //         //     }
                    //         //     $( api.column( i ).footer() ).html(
                    //         //         ''+precentage
                    //         //     );
                    //          }
                    //
                    //     },
                } );
                MergeGridCells();
            }, 200);
        });
    }

    login_report_download (e){
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);

        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: ''
        });
        var postData = {
            user_type: this.state.uTypeIDs,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            download: true
        };

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/login-report-download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName = timestamp+'User_Login_Report.csv';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    render() {
        // console.log(this.state.tableBody);
        // console.log(this.state.tableHeaders);
        const footerHead =this.state.tableHeaders.map((fooHeader, i) => {
            if(i>1) {
                return (
                    <th key={i} style={{textAlign: 'right'}}></th>
                )
            }
        });
        const headersList =this.state.tableHeaders.map((header, i) => {
            return (
                <th width="70" key={i}>{header}</th>
            )
        });

        const tableData = this.state.tableBody.map((data, index) => {
            var rowCls = "sgrouptotal";

            if(index==3 || index==7 || index==11 || index==15 || index==19){
                rowCls = "";
            }
             return (
                <tr key={index} className={rowCls}>
                    {this.state.tableHeaders.map((value1, index1) => {
                        var tdclass = '';
                        if(index1==0 || data[value1]=='All Cities'){
                            tdclass = "back-td";
                        }
                        if(index1>3){
                            tdclass = "text-right";
                        }

                        if(data[value1].hasOwnProperty('value')===true) {
                            return <td width="70" key={index1} style={{backgroundColor: data[value1].color, textAlign: 'right'}}>{data[value1].value}%</td>
                        }
                        else {

                            return <td width="70" key={index1} className={tdclass} >{data[value1]}</td>
                        }
                        // var tdclass = ''
                        // if(index1==0 || data[value1]=='Total'){
                        //     tdclass = "back-td";
                        // }
                        // if(index1<2) {
                        //     r
                        // } else if(index1>10) {
                        //     return <td key={index1} style={{textAlign: 'right'}} className={tdclass} >{data[value1]}</td>
                        // }
                        // else {
                        //
                        // }

                    })}
                </tr>
            )
        });


        return(
          
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Bounce Back Indicator Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={20}
                                        color={'#123abc'}
                                        loading={this.state.loading}
                                    />
                                    <div className="">
                                        {/*<div className="col-md-2 filter-bottom5 padd-5 date-icon-small">*/}
                                        {/*    <div><label> Date Filter: </label></div>*/}
                                        {/*    <DateRangePicker startDate={this.state.datefrom} endDate={this.state.dateTo}*/}
                                        {/*                     onEvent={this.handleEvent.bind(this)}  maxDate = {this.state.dateLimit}>*/}
                                        {/*        <i className="fa fa-calendar" aria-hidden="true"></i>*/}
                                        {/*        <input type="text" name="dateRange"*/}
                                        {/*               className="form-control dateRangeInput"*/}
                                        {/*               value={this.state.datefromShow + ' - ' + this.state.dateToShow}/>*/}
                                        {/*    </DateRangePicker>*/}
                                        {/*</div>*/}
                                        {/*<div className="col-md-2 filter-bottom5 date-icon-small">*/}

                                        {/*    <div className="form-group">*/}
                                        {/*        <label htmlFor="queryName" className="">User Type</label>*/}
                                        {/*        <ReactMultiSelectCheckboxes name="subvention"*/}
                                        {/*            isMulti*/}
                                        {/*            value={this.state.uTypeValue}*/}
                                        {/*            styles={customStyles} className="report-listbox"*/}
                                        {/*            isClearable={false}*/}
                                        {/*            onChange={this.changeUserType.bind(this)}*/}
                                        {/*            options={this.state.uTypeLists}*/}
                                        {/*            placeholderButtonLabel="Select [User Type]"*/}
                                        {/*        />*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}

                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    {/*<div className="">*/}
                                    {/*    <a href="#" className="exportButton" role="button" onClick={this.login_report_download.bind(this)}>*/}
                                    {/*        <i className="fa fa-download" aria-hidden="true"></i>*/}
                                    {/*        Export to CSV*/}
                                    {/*    </a>*/}
                                    {/*</div>*/}
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="BBIRTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    {headersList}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {tableData}
                                            </tbody>
                                            {/*<tfoot>*/}
                                            {/*<tr>*/}
                                            {/*    <th width="70"></th>*/}
                                            {/*    <th width="70"></th>*/}
                                            {/*    {footerHead}*/}

                                            {/*</tr>*/}
                                            {/*</tfoot>*/}
                                        </table>
                                    </div>
                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        <p>Generating CSV...</p>
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         
        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(BounceBackIndicatorReport)